import './css/index.css';
import LottoMachineView from './js/view/lottoMachineView';

// eslint-disable-next-line no-new
new LottoMachineView();
